// src/components/Skills.js
import React from 'react';
import { Box, Typography, Container, Grid, Chip } from '@mui/material';
import { useText } from '../context/TextContext';
const Skills = () => {
    const textData = useText();
    const skills = textData.skills;
  return (
    <Box id="skills" sx={{ padding: 4, backgroundColor: '#FFFFFF', border: '1px solid #EDEBE9', borderRadius: 1, my: 2 }}>
      <Container disableGutters>
        <Typography variant="h4" gutterBottom sx={{ color: '#0078D4' }}>Skills</Typography>

        {textData.priorityKeywords?.length > 0 && (
          <>
            <Typography variant="h6" gutterBottom>Core Keywords</Typography>
            <Grid container spacing={1} sx={{ marginBottom: 3 }}>
              {textData.priorityKeywords.map((skill, index) => (
                <Grid item key={index}>
                  <Chip label={skill} color="primary" sx={{ fontWeight: 600 }} />
                </Grid>
              ))}
            </Grid>
          </>
        )}
        
        <Typography variant="h6" gutterBottom>Main Skills</Typography>
        <Grid container spacing={1}>
          {skills.main.map((skill, index) => (
            <Grid item key={index}>
              <Chip label={skill} variant="outlined" color="primary" />
            </Grid>
          ))}
        </Grid>

        <Typography variant="h6" gutterBottom sx={{ marginTop: 3 }}>Other Skills</Typography>
        <Grid container spacing={1}>
          {skills.other.map((skill, index) => (
            <Grid item key={index}>
              <Chip label={skill} variant="outlined" color="secondary" />
            </Grid>
          ))}
        </Grid>

        {skills.integrations && (
          <>
            <Typography variant="h6" gutterBottom sx={{ marginTop: 3 }}>Integrations</Typography>
            <Grid container spacing={1}>
              {skills.integrations.map((skill, index) => (
                <Grid item key={index}>
                  <Chip label={skill} variant="outlined" color="success" />
                </Grid>
              ))}
            </Grid>
          </>
        )}

        {skills.aiTools && (
          <>
            <Typography variant="h6" gutterBottom sx={{ marginTop: 3 }}>AI Tools</Typography>
            <Grid container spacing={1}>
              {skills.aiTools.map((tool, index) => (
                <Grid item key={index}>
                  <Chip label={tool} variant="outlined" color="primary" sx={{ backgroundColor: 'rgba(0, 188, 242, 0.12)', borderColor: '#00BCF2' }} />
                </Grid>
              ))}
            </Grid>
          </>
        )}
      </Container>
    </Box>
  );
};

export default Skills;
